import { create } from 'zustand';

export type FeedTab = 'discover' | 'nearby';
export type FeedTimeWindow = 'all' | 'now' | 'today' | 'tonight' | 'tomorrow' | 'weekend' | 'week';
export type FeedDistanceFilter = 1600 | 8000 | 16000 | 40000 | 80000;

type FeedPreferencesState = {
  feedTab: FeedTab;
  timeWindow: FeedTimeWindow;
  radiusMeters: FeedDistanceFilter;
  setFeedTab: (value: FeedTab) => void;
  setTimeWindow: (value: FeedTimeWindow) => void;
  setRadiusMeters: (value: FeedDistanceFilter) => void;
};

export const useFeedPreferences = create<FeedPreferencesState>((set) => ({
  feedTab: 'discover',
  timeWindow: 'week',
  radiusMeters: 16000,
  setFeedTab: (value) => set({ feedTab: value }),
  setTimeWindow: (value) => set({ timeWindow: value }),
  setRadiusMeters: (value) => set({ radiusMeters: value }),
}));
